<template>
  <div v-if="(source = 'qrsanchopan2025')" class="container contactenos">
    <div class="container section text-center py-3">
      <h2>Contáctenos</h2>
      <div :class="clasesRowInfo">
        <div :class="clasesInfoContactenos">
          <h2 class="mt-1 mb-1">SEDE MONTERÍA</h2>
          <h3 class="mt-1 mb-1">Terminal de buses de la pradera</h3>
          <h3 class="mt-1 mb-1">Teléfonos</h3>
          <h4 class="mt-1 mb-1">310 627 7803</h4>
          <h3 class="mt-1 mb-1">Whatsapp recepción:</h3>
          <h4 class="mt-1 mb-1">310 627 7803</h4>
          <h3 class="mt-1 mb-1">Whatsapp pedidos:</h3>
          <h4 class="mt-1 mb-1">313 530 2175</h4>
        </div>
      </div>
      <div :class="clasesRowInfo">
        <div :class="clasesInfoContactenos">
          <h2 class="mt-1 mb-1">AGENCIA CERETÉ</h2>
          <h3 class="mt-1 mb-1">Calle 13 No. 8B-02 B/ San Francisco</h3>
          <h3 class="mt-1 mb-1">Teléfonos</h3>
          <h4 class="mt-1 mb-1">604 7748430</h4>
        </div>
      </div>
      <div :class="clasesRowInfo">
        <div :class="clasesInfoContactenos">
          <h2 class="mt-1 mb-1">AGENCIA LORICA</h2>
          <h3 class="mt-1 mb-1">Carrera 29A N°17B Barrio La Gloria</h3>
          <h3 class="mt-1 mb-1">Teléfonos</h3>
          <h4 class="mt-1 mb-1">604 7732019</h4>
        </div>
      </div>
      <div :class="clasesRowInfo">
        <div :class="clasesInfoContactenos">
          <h2 class="mt-1 mb-1">AGENCIA SINCELEJO</h2>
          <h3 class="mt-1 mb-1">Calle 38-158-Troncal Occidente</h3>
          <h3 class="mt-1 mb-1">Teléfonos</h3>
          <h4 class="mt-1 mb-1">605 2764576</h4>
          <h4 class="mt-1 mb-1">311 411 8356</h4>
        </div>
      </div>
      <div :class="clasesRowInfo">
        <div :class="clasesInfoContactenos">
          <h4 class="mt-1 mb-1">recepcion@sanchopan.com</h4>
          <h4 class="mt-1">sanchopan@sanchopan.com</h4>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="container contactenos">
    <div class="container section text-center py-3">
      <h2>Contáctenos</h2>
      <div :class="clasesRowInfo">
        <div :class="clasesIconosGrandes">
          <span class="fa-stack fa-3x">
            <i class="fa fa-circle fa-stack-2x icon-background"></i>
            <i class="fas fa-phone fa-stack-1x icon-info"></i>
          </span>
        </div>
        <div :class="clasesIconosPequenos">
          <span class="fa-stack fa-2x">
            <i class="fa fa-circle fa-stack-2x icon-background"></i>
            <i class="fas fa-phone fa-stack-1x icon-info"></i>
          </span>
        </div>
        <div :class="clasesInfoContactenos">
          <h4 class="mt-1 mb-1">310 627 7803</h4>
          <h4 class="mt-1 mb-1">(4) 783 50 60</h4>
          <h4 class="mt-1 mb-1">(4) 783 41 52</h4>
        </div>
      </div>
      <div :class="clasesRowInfo">
        <div :class="clasesIconosGrandes">
          <span class="fa-stack fa-3x">
            <i class="fa fa-circle fa-stack-2x icon-background"></i>
            <i class="fas fa-map-marker-alt  fa-stack-1x  icon-info"></i>
          </span>
        </div>
        <div :class="clasesIconosPequenos">
          <span class="fa-stack fa-2x">
            <i class="fa fa-circle fa-stack-2x icon-background"></i>
            <i class="fas fa-map-marker-alt  fa-stack-1x  icon-info"></i>
          </span>
        </div>
        <div :class="clasesInfoContactenos">
          <h4 class="mt-1 mb-1">Carrera 27D No. 9C-78</h4>
          <h4 class="mt-1 mb-1">Terminal de buses.</h4>
          <h4 class="my-1 ">Barrio La Pradera</h4>
        </div>
      </div>
      <div :class="clasesRowInfo">
        <div :class="clasesIconosGrandes">
          <span class="fa-stack fa-3x">
            <i class="fa fa-circle fa-stack-2x icon-background"></i>
            <i class="fas fa-at fa-stack-1x  icon-info"></i>
          </span>
        </div>
        <div :class="clasesIconosPequenos">
          <span class="fa-stack fa-2x">
            <i class="fa fa-circle fa-stack-2x icon-background"></i>
            <i class="fas fa-at fa-stack-1x  icon-info"></i>
          </span>
        </div>
        <div :class="clasesInfoContactenos">
          <h4 class="mt-1 mb-1">recepcion@sanchopan.com</h4>
          <h4 class="mt-1">sanchopan@sanchopan.com</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contactenos",
  mounted() {
    this.source = this.$route.query.source;
  },
  data() {
    return {
      source: "",
      clasesIconosGrandes: [
        "col-sm-5",
        "d-none",
        "d-sm-block",
        "text-xs-center",
        "text-sm-right",
        "my-auto",
        "pr-0",
      ],
      clasesIconosPequenos: [
        "col-xs-12",
        "d-sm-none",
        "d-xs-block",
        "text-xs-center",
        "text-sm-right",
        "my-auto",
      ],
      clasesInfoContactenos: [
        "col-xs-12",
        "col-sm-7",
        "text-xs-center",
        "text-sm-left",
        "mb-2",
        "my-auto",
        "pb-0",
      ],
      clasesRowInfo: ["row", "justify-content-center", "mb-4"],
    };
  },
};
</script>
<style>
.contactenos {
  min-height: calc(100vh - 300px);
}

.icon-info {
  color: white;
}

.icon-background {
  color: rgb(195, 22, 50);
}
</style>
